<div class="w-100 d-flex flex-wrap pb-big">
  <ngx-app-bar
    class="w-100"
    [title]="'سبد دارایی'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
    [leftIcon]="canSee() ? 'eye' : 'hide'"
    (onLeftIconClick)="changeSeeStatus()"
  />

  @if (loading()) {
    <app-spinner></app-spinner>
  } @else {
    <div class="px-big portfo-container">
      <div class="mt-medium">
        <app-portfo-assets
          [assets]="assetData"
          [canSee]="canSee()"
        >
        </app-portfo-assets>
      </div>

      <div class="mt-big">
        <wealth-applet-portfo-pending-transactions
          [transactions]="transactions()"
          [type]="type()"
          [totalUnits]="totalUnits()"
          [totalAmount]="totalAmount()"
          [loadingTransactions]="loadingTransactions()"
          [canSee]="canSee()"
          [state]="state()"
          (updateFilter)="updateFilter($event)"
          (goToTransactions)="goToTransactions()"
        />
      </div>

      @if (walletBalance() !== null) {
        <div class="mt-big">
          <app-portfo-etf
            [canSee]="canSee()"
            [balance]="walletBalance()"
            [showWithdrawButton]="canWithdraw()"
          >
          </app-portfo-etf>
        </div>
      }

      <div class="mt-big">
        <app-portfo-profiles-asset
          [canSee]="canSee()"
          [assetData]="assetData?.portfolioDetails"
          [balance]="assetBalance()"
          [crowdBalance]="crowdBalance()"
          [ipoBalance]="ipoBalance()"
          [stockBalance]="stockBalance()"
        >
        </app-portfo-profiles-asset>
      </div>
    </div>
  }
</div>
